import {
  Alert,
  Breadcrumb,
  Button,
  Card,
  Form,
  Input,
  Radio,
  Space,
} from 'antd';
import { useNavigator } from '../../../useNavigator';
import {
  assetCreate,
  assetCreateDTO,
} from '../../../modules/apis/neo/assetCreate';
import { RepositoryType } from '../../../modules/apis/types';
import { OptionGroup } from '../../../components/OptionGroup';
import {
  inferenceTypeOptions,
  licenseOptions,
} from '../../../modules/apis/options';
import { toast } from 'react-toastify';

const typeOptions = [
  {
    value: false,
    label: (
      <div>
        <h5>Public</h5>
        <p>
          Anyone on the internet can see this model. Only you (personal model)
          or members of your organization (organization model) can commit.
        </p>
      </div>
    ),
  },
  {
    value: true,
    label: (
      <div>
        <h5>Private</h5>
        <p>
          Only you (personal model) or members of your organization
          (organization model) can see and commit to this model.
        </p>
      </div>
    ),
  },
];

export default function ModelCreate() {
  const navigator = useNavigator();
  const [form] = Form.useForm<assetCreateDTO.Req>();

  return (
    <main className='p-5'>
      <Breadcrumb
        items={[
          {
            title: <a>← Back</a>,
            onClick: () => navigator.go(-1),
          },
        ]}
      />
      <Card
        bordered={false}
        style={{
          boxShadow: 'none',
          width: '50%',
          minWidth: 500,
          maxWidth: 800,
          margin: '0 auto',
        }}
        headStyle={{ borderBottom: '0 none' }}
        title={
          <div className='text-center'>
            <h3 className='text-lg'>Create a new model repository</h3>
            <p className='text-sm font-normal text-gray-600'>
              A repository contains all model files, including the revision
              history.
            </p>
          </div>
        }
      >
        <Form
          layout='vertical'
          form={form}
          onFinish={(values) => {
            values.type = RepositoryType.RepositoryTypeModel;
            assetCreate(values).then(
              () => {
                toast.success('Model create successfully');
                navigator.push('/aiweb/models');
              },
              (err) => {
                toast.error(err.message);
              }
            );
          }}
        >
          {/* <Row gutter={24}>
            <Col span={6}>
              <Form.Item label='Owner' name='owner'>
                <Input placeholder='Owner Name' />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label='Model name' name='name'>
                <Input placeholder='New Model Name' />
              </Form.Item>
            </Col>
          </Row> */}
          <Form.Item label='Model name' name='name'>
            <Input placeholder='New Model Name' />
          </Form.Item>
          <Form.Item label='License' name='license'>
            <Radio.Group options={licenseOptions} />
          </Form.Item>
          <Form.Item label='Type' name='private'>
            <Radio.Group>
              <Space direction='vertical'>
                {typeOptions.map((item, index) => {
                  return (
                    <div key={index} className='border border-gray-300 p-3'>
                      <Radio value={item.value}>{item.label}</Radio>
                    </div>
                  );
                })}
              </Space>
            </Radio.Group>
          </Form.Item>
          <Form.Item label='Select category' name='modality'>
            <OptionGroup options={inferenceTypeOptions} />
          </Form.Item>
          <Form.Item label='Description' name='description'>
            <Input.TextArea placeholder='Input Description' rows={6} />
          </Form.Item>
          <Form.Item>
            <Alert
              type='info'
              message='Once your model is created, you can upload your files using the web interface or git.'
            />
          </Form.Item>
          <Form.Item style={{ textAlign: 'center' }}>
            <Button type='primary' htmlType='submit'>
              Create Model
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </main>
  );
}
